// image.service.ts
import { Component, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { getStoredAuthToken } from '../../auth/auth-token';

@Injectable({ providedIn: 'root' })
export class UserRatingService {
  private readonly platformId = inject(PLATFORM_ID);

  constructor(private http: HttpClient) {}

  getUserRatings():Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/user/ratings`,{
      headers: this.authHeaders()
    });
  }

  addRating(data: any, rating: number, type: string = 'movie'): Observable<any> {
    const payload = {
      tmdb_data: data,
      rating: rating,
      type: type,
      added_at: new Date().toISOString()
    };
    return this.http.post<any>(`${environment.backendUrl}/api/ratings/add`, payload, {
      headers: this.authHeaders()
    });
  }

  removeRating(index: number, id?: string): Observable<any> {
    const params: any = { index: String(index) };
    if (id) {
      params['id'] = String(id);
    }
    return this.http.delete<any>(`${environment.backendUrl}/api/user/ratings/remove`, {
      params,
      headers: this.authHeaders()
    });
  }

  private authHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.getAuthToken() ?? ''}`,
    });
  }

  private getAuthToken(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    return getStoredAuthToken();
  }

}
